export const useIsLandscape = () => {
  return false
}
